.ds-password {
  position: relative;
  z-index: 1;
  display: block;
  
  &__input {
    position: relative;
    z-index: 5;
  }
  
  &__button {
    position: absolute;
    z-index: 10;
    top: 0;
    right: 0;
    min-width: 1rem;
  }
}